import { render, staticRenderFns } from "./ExpoChapterQuestionsWidget.vue?vue&type=template&id=4ef68926&scoped=true"
import script from "./ExpoChapterQuestionsWidget.vue?vue&type=script&lang=js"
export * from "./ExpoChapterQuestionsWidget.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterQuestionsWidget.vue?vue&type=style&index=0&id=4ef68926&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef68926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef68926')) {
      api.createRecord('4ef68926', component.options)
    } else {
      api.reload('4ef68926', component.options)
    }
    module.hot.accept("./ExpoChapterQuestionsWidget.vue?vue&type=template&id=4ef68926&scoped=true", function () {
      api.rerender('4ef68926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ExpoChapterQuestionsWidget.vue"
export default component.exports